import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import PostMeta from 'flarum/forum/components/PostMeta';
import EventPost from 'flarum/forum/components/EventPost';
import classList from 'flarum/common/utils/classList';
// A post's date and time as champis.net's phpBB shows it ("01 oct. 2026,
// 18:28"), instead of core's relative humanTime() ("il y a 3 jours").
// Core's full date stays in the tooltip. No data-humantime attribute:
// core's liveHumanTimes() rewrites every element carrying it back to the
// relative form every minute.
//
// `dayjs` is core's global instance (see its global.d.ts), deliberately
// not imported: an `import dayjs from 'dayjs'` bundles a second copy
// without the French locale the language pack sets nor core's
// localizedFormat plugin - "03 Oct", and an "LLLL" tooltip.
function postDateTime(time) {
  const date = dayjs(time);
  return m("time", {
    datetime: date.format(),
    title: app.translator.formatDateTime(date, 'core.lib.datetime_formats.fullTime')
  }, date.format('DD MMM YYYY, HH:mm'));
}
export default function showPostDateTime() {
  // The date at the top of every post (and private message) - the same
  // permalink dropdown toggle as core's, only its label changes.
  extend(PostMeta.prototype, 'viewItems', function (items) {
    if (!items.has('time')) return;
    const permalink = this.getPermalink(this.attrs.post);
    items.setContent('time', m("button", {
      type: "button",
      className: classList({
        'Button Button--text': true,
        'Dropdown-toggle Button--link': !!permalink
      }),
      onclick: permalink ? this.selectPermalink.bind(this) : undefined,
      "data-toggle": "dropdown"
    }, postDateTime(this.attrs.post.createdAt())));
  });

  // "X a renommé le titre en … le {time}." - the French pack's event posts
  // already read "le {time}", which a relative time made "le il y a 3 jours".
  // EventPost.content() builds `time` and hands it to this.description(),
  // which some subclasses redefine (DiscussionRenamedPost) - so the time is
  // swapped there, for the duration of that one call, rather than in
  // EventPost's own description().
  override(EventPost.prototype, 'content', function (original) {
    const description = this.description;
    this.description = data => description.call(this, {
      ...data,
      time: postDateTime(this.attrs.post.createdAt())
    });
    try {
      return original();
    } finally {
      // Back to the prototype's (or subclass') own method.
      delete this.description;
    }
  });
}